module.exports = __webpack_public_path__ + "img/about@2x.b4d65075.jpg";